import formGroupIngestServerEdit from './formGroupIngestServerEdit';

export default {
  title: 'Ingest server Edit',
  attributeName: 'ingestServer',
  createURL: 'ingestserver',
  sessionParams: [],
  getURL: 'ingestserver',
  updateURL: 'ingestserver',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroupIngestServerEdit,
  ],
  // websocketNavigation:'users_navigation',

};
